import { Dialog } from "@mui/material";
import AddUserForm from "./AddUserForm";

const AddUserModal = ({ open, onClose, clubData, onSuccess }) => {
  const handleUserSuccess = (response) => {
    if (response?.data?.s === 1) {
      onClose();
      if (onSuccess) {
        onSuccess();
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "15px",
          maxHeight: "90vh",
          overflow: "scroll",
        },
      }}
    >
      <AddUserForm 
        onClose={onClose} 
        clubData={clubData}
        onSuccess={handleUserSuccess}
        setCurrentStep={() => {}} // Not needed for standalone modal
      />
    </Dialog>
  );
};

export default AddUserModal;